module.exports = __webpack_public_path__ + "static/media/map-marker-minus.092400c5.svg";